export const slide = [
  {
    image: "/img/history/foundation_img.png",
    year: "1998 –",
    title: "Foundation",
    subtitle: "Established with a vision to transform animal health and nutrition.",
  },
  {
    image: "/img/history/market_entry_img.png",
    year: "1999 –",
    title: "Market Entry",
    subtitle: "Marked presence in the industry by setting up our own manufacturing facility.",
  },
  {
    image: "/img/history/excellence_img.png",
    year: "2008 –",
    title: "A Decade of Excellence",
    subtitle: "Celebrated 10 years of impactful operations and industry presence.",
  },
  {
    image: "/img/history/global_standards_img.png",
    year: "2010 –",
    title: "Foundation for Global Standards.",
    subtitle: "Established unified global standards to drive quality, consistency, and regulatory compliance across international markets.",
  },
  {
    image: "/img/history/global_expansion_img.png",
    year: "2012 – 2015 -",
    title: "Global Expansion",
    subtitle: "Strengthened international footprint with the inauguration of subsidiaries in Vietnam, Singapore, Thailand, and Indonesia.",
  },
  {
    image: "/img/history/company_growth_img.png",
    year: "2018 – 2019 –",
    title: "Capacity & Capability Growth",
    subtitle: "Expanded production capacity and significantly enhanced R&D infrastructure.",
  },
  {
    image: "/img/history/diversification_img.png",
    year: "2020 –",
    title: "Portfolio Diversification",
    subtitle: "Entered new market segments with the launch of swine and companion animal product lines.",
  },
  {
    image: "/img/history/growth_innovation_1.png",
    year: "2021 -",
    title: "Breakthrough Innovations",
    subtitle: "Introduced the world's first Tribiotic product.",
  },
  {
    image: "/img/history/technology_innovation_img.png",
    year: "2022 –",
    title: "Technology-Driven Innovation",
    subtitle: "Rolled out a revolutionary product featuring Quadramax Technology.",
  },
  {
    image: "/img/history/silver_jublee_img.png",
    year: "2023 –",
    title: "Silver Jubilee Milestone",
    subtitle: "Proudly celebrated 25 years of innovation, excellence, and growth.",
  },
  
];

